import { buildUrl } from './Utils'

/* -------------------------------------------------------------------------- */
/*                                   PUBLIC                                   */
/* -------------------------------------------------------------------------- */

export const PUBLIC_BOOKABLE_SLOTS = (assetId: string, agent?: string): string => {
  let url = `/api/public/bookables/?asset=${assetId}`
  if (agent && agent !== 'all') {
    url += `&agent_id=${agent}`
  }

  return buildUrl(url)
}
